module.exports = __webpack_public_path__ + "static/img/g_mzjg_icon.png";